import { Suspense, useEffect, useContext, useMemo, useCallback, useState } from "react";
import { Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType, CustomWaiveForm } from "../../../../../../../types/components/dialogProps.types";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import {
	LazyBrandingActions,
	LazyCustomFormDialog,
	LazyCustomWaiveFormDialog,
	LazyPlanBranding
} from "../../../../../../shared";
import { IntercityHealthPlanBrandingLogo } from "../../../../../../../assets";
import { BrandingProps } from "../../../../../../../types/components/enrollmentProps.types";
import { AuthContext } from "../../../../../../../contexts";
import { CommonDetails, StandardDetails } from "../../../../../../../types/enrollment.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { AddEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { dateTimeZoneConverter, getCurrentDate } from "../../../../../../../utils/commonFunctions/date";
import { WaiveCoverageFormType } from "../../../../../../../types/waiveDialogForm.types";
import { generateICIGLTDPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/ICIEnrollment/ICICoreEnrollment/ICICoreEnrollment";

const IntercityHealthPlanBranding = ({ status, openEnrollment, isActiveEnrollment }: BrandingProps) => {
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomWaiveForm>();
	const [submitWaiveFormStatus, setSubmitWaiveFormStatus] = useState<boolean>(false);
	const [waiveCoverageForm, setWaiveCoverageForm] = useState<any>({
		waive_reason: "",
		is_employee_cost: null,
		another_group_insurance: ""
	});

	const handleDialogClose = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: false
			})
		);
	}, [customFormDialogProps]);

	const handleWaiveReasonChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { value, name, checked, type } = event.target;

		setWaiveCoverageForm((prevValue: any) => {
			return {
				...prevValue, // Using spread operator for a shallow copy
				[name]: type === "checkbox" ? checked : value
			};
		});
	}, []);

	const handleWaiveSubmition = useCallback(
		(waiveCoverageForm: WaiveCoverageFormType) => {
			setCustomFormDialogProps(
				Object.assign({}, customFormDialogProps, {
					openDialog: false
				})
			);
			handleWaiveEnrollment();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[customFormDialogProps, waiveCoverageForm]
	);

	const handleWaiveSubmitClick = useCallback(() => {
		setSubmitWaiveFormStatus((prevValue: any) => !prevValue);
	}, []);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateICIGLTDPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveCoverageForm
		);
		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			debugger;
		}
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: commonDetails
		};
		const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		const step = urlSearchParams.get("step");
		if (response) {
			history.push(`?step=${step}&stage=2`);
		}
	}, [history, isActiveEnrollment, member, openEnrollment, urlSearchParams, waiveCoverageForm]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Waivers Coverage Form",
				description:
					"The Group Health Plan has been offered to me and after seriously considering benefits I have decided not to enroll myself or my dependents in the Plan. I understand that i and my dependents must wait until the next open enrollment period unless a change of family and/or job status occur",

				inputFields: [
					{
						label: "Coverage Elsewhere",
						name: "waive_reason",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_reason,
						placeholder: "Name of carrier"
					},
					{
						label: "Employee Cost",
						name: "waive_employee_cost",
						type: "checkbox",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_employee_cost,
						placeholder: ""
					},
					{
						label: "Other",
						name: "other_waive_coverage",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.other_waive_coverage,
						placeholder: "State the other reason"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							)
					},
					{
						label: "Yes",
						callback: () => handleWaiveSubmitClick()
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveReasonChange, handleWaiveSubmitClick, waiveCoverageForm]);

	const handleEnrollButtonClick = useCallback(() => {
		// console.log("openEnrollment", status);
		if (status.openEnrollment === "CLOSED") {
			alert("Enrollment has not been opened for this plan. Please contact your administrator");
		} else {
			// // console.log("openEnrollment22", status);
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=1`);
		}
	}, [history, urlSearchParams, status]);

	// console.log("customFormDialogProps", customFormDialogProps);

	useEffect(() => {
		if (submitWaiveFormStatus && waiveCoverageForm) handleWaiveSubmition(waiveCoverageForm);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitWaiveFormStatus, waiveCoverageForm]);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? (
					<LazyCustomWaiveFormDialog
						customFormDialogProps={customFormDialogProps}
						handleDialogClose={handleDialogClose}
						date={dateTimeZoneConverter(getCurrentDate()) as unknown as string}
					/>
				) : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				<PlanHeader planName="Health Plan" planCode={openEnrollment?.plan?.plan_code} />
				<div className="theme-plan-section-margin" />
				<Suspense fallback={<div />}>
					<LazyPlanBranding imgSrc={IntercityHealthPlanBrandingLogo} />
				</Suspense>
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default IntercityHealthPlanBranding;
